export const diarySharingConstants = {
    FETCH_REQUEST: 'DIARY_SHARING_FETCH_REQUEST',
    FETCH_SUCCESS: 'DIARY_SHARING_FETCH_SUCCESS',
    FETCH_FAILURE: 'DIARY_SHARING_FETCH_FAILURE',

    UPDATE_BULK: 'DIARY_SHARING_UPDATE_BULK',
    UPDATE_STAFF: 'DIARY_SHARING_UPDATE_STAFF',

    VISIBILITY_LOAD: 'DIARY_SHARING_VISIBILITY_LOAD',
};

export const DIARY_VISIBILITY_MODES = ['everyone', 'selected', 'nobody'];
